import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { first } from 'rxjs/operators';
import { ReportService } from '../../../../_components/report';
import { ReservationService } from '../../../../_components/reservation';
import { TaskService } from '../../../../_components/task';
import { AlertService } from '../../../../_services';

@Component({
    selector: 'app-reservation-select',
    templateUrl: './reservation-select.component.html',
    styleUrls: ['./reservation-select.component.css'],
    standalone: false
})
export class ReservationSelectComponent implements OnInit {

  	texts: string[] = [];
	reservationSuggestions: string[];
	reservationSelectForm: UntypedFormGroup;
	reservation: any;
	@Output() reservationInfoEvent = new EventEmitter<any>();
	@Input() title: any;
	@Input() reservationId: any;
	summary: any;
	@Input() placeholder: string = 'Please enter the Reservation ID and select the reservation from the dropdown';

	constructor(
		private formBuilder: UntypedFormBuilder,
		private reservationService: ReservationService,
		private alertService: AlertService) { }

	ngOnInit()
	{
		this.reservationSelectForm = this.formBuilder.group({
			reservation: [],
		});
		if(this.reservationId){
			this.fetchReservationById(this.reservationId);
			// this.reservationSelectForm.patchValue({
			// 	reservation: this.reservationId
			// });
		}
	}
	
	fetchReservationById(reservationId: any) {
			try {
				this.reservationService.findById(reservationId)
					.subscribe(
						res => {
							this.reservation = res.data.reservation;
							this.reservation.summary = this.reservation.shortTermRental.propertyCode+" "+this.reservation.guestProfile.lastName.toUpperCase()+" "+moment(this.reservation.checkInDate).format("MMM DD")+"-"+moment(this.reservation.checkOutDate).format("MMM DD YY");
							this.reservationInfoEvent.emit(this.reservation);
							console.log('findById reservation : ' + JSON.stringify(this.reservation));
							this.reservationSelectForm.patchValue({
								reservation: this.reservation,
							});
							return this.reservation;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}

	// for each letter typed in autocomplete...
	onKeyInput(event)
	{
		let query = event.query;
		this.findReservationsWith(query);
		return this.reservationSuggestions;
	}

	// not used.
	onKeyUp(event: KeyboardEvent)
	{
		if (event.key === 'Enter')
		{
			let tokenInput = event.srcElement as any;
			console.log('tokenInput ' + JSON.stringify(tokenInput.value));
			if (tokenInput.value)
			{
				this.reservationSuggestions.push(tokenInput.value);
				tokenInput.value = '';
			}
		}
	}

	onSelect(event)
	{
			// assemble the payload manually since we are using primeng
			console.log('onSelect: ' + JSON.stringify(event));
			const selected = event?.value ?? event;
			let data: any = {};
			data.reservationId = selected?.reservationId;
			data.shortTermRentalId = selected?.shortTermRentalId;
			this.reservationInfoEvent.emit(selected);
			console.log('onSelect: ' + JSON.stringify(data));
	}


	onUnselect(event)
	{
		// assemble the payload manually since we are using primeng
		const selected = event?.value ?? event;
		let data: any = {};
		data.reservationId = selected?.reservationId;
		console.log('onUnselect: ' + JSON.stringify(data));
	}

	findReservationsWith(queryString: string)
	{
		this.reservationService.findReservationsWith(queryString).pipe(first()).subscribe(

			data =>
			{
				console.log('reservation serach: ' + JSON.stringify(data));
				this.reservationSuggestions = [];
				this.reservationSuggestions = data.data.reservationSummaryList;
				// console.log('QA: ' + JSON.stringify(this.reservationSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}
}
